import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import Title from "./Title";
import Content from "./Content";

const Blog = () => {
	return (
		<>
			<Header />
			<Title />
			<Content />
			<Footer />
		</>
	);
};
export default Blog;
